module.exports = __webpack_public_path__ + "img/hr-pipe-straight-vertical.429d2a44.png";